import { Component, computed, inject } from '@angular/core';
import { CategoryService, ProductCatalogService } from 'shared';

export interface CategoryCard {
  title: string;
  count: string;
  image: string;
}

export interface ProductCard {
  slug: string;
  name: string;
  price: string;
  oldPrice?: string;
  image: string;
  tag?: string;
}

export interface BenefitItem {
  title: string;
  description: string;
  icon: 'truck' | 'shield' | 'card' | 'refresh';
}

const CATEGORY_IMAGES: Record<string, string> = {
  recamaras: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=800&q=80',
  muebles:   'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=800&q=80',
};
const DEFAULT_CAT_IMAGE = 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  private readonly catalog = inject(ProductCatalogService);
  private readonly categoryService = inject(CategoryService);

  readonly categories = computed<CategoryCard[]>(() => {
    const products = this.catalog.products();
    return this.categoryService.categories()
      .filter((c) => c.isActive)
      .map((c) => {
        const n = products.filter((p) => p.category === c.slug).length;
        return {
          title: c.name,
          count: n ? `${n} producto${n !== 1 ? 's' : ''}` : '',
          image: CATEGORY_IMAGES[c.slug] ?? DEFAULT_CAT_IMAGE,
        };
      });
  });

  readonly featured = computed<ProductCard[]>(() =>
    this.catalog.featuredProducts().map((p) => ({
      slug: p.slug,
      name: p.name,
      price: p.price,
      oldPrice: p.oldPrice,
      image: p.image,
      tag: p.tag?.text
    }))
  );

  readonly benefits: BenefitItem[] = [
    {
      icon: 'truck',
      title: 'Envío Gratis',
      description: 'En compras mayores a $10,000'
    },
    {
      icon: 'shield',
      title: 'Garantía 1 Año',
      description: 'En todos nuestros productos'
    },
    {
      icon: 'card',
      title: '3 y 6 MSI',
      description: 'Meses sin intereses'
    },
    {
      icon: 'truck',
      title: 'Envíos a Toda la República',
      description: 'Llevamos tu pedido a cualquier estado'
    }
  ];

  noopClick(event: Event): void {
    event.preventDefault();
  }
}
